export default __webpack_public_path__ + "static/media/phone.ab2ed2ab.svg";